export default __webpack_public_path__ + "static/media/principal.4ca66bec.svg";